import { FormattedNumber, useIntl } from 'react-intl'
import { format } from 'date-fns'

import type { ColumnDef } from '@gto/ui/data-table'
import { createColumns } from '@gto/ui/data-table'
import { TruncatedText } from '@gto/ui/truncated-text'

import type { TransactionHistory } from '@/api/gen'
import { fluidColumn } from '@/components/table-columns'

export const useAuditHistoryTableCols = (): ColumnDef<TransactionHistory>[] => {
  const { formatMessage } = useIntl()

  return createColumns<TransactionHistory>([
    {
      accessorKey: 'date',
      header: formatMessage({ id: 'rewards.earnings.table.date' }),
      ...fluidColumn({ min: 75, align: 'center', headerAlign: 'center' }),
      cell: ({ row }) => format(new Date(row.original.date), 'MMMM dd, yyyy'),
    },
    {
      accessorKey: 'amount',
      header: formatMessage({ id: 'rewards.earnings.table.cost' }),
      ...fluidColumn({ min: 120, align: 'center', headerAlign: 'center' }),
      cell: ({ row }) => <FormattedNumber value={row.original.amount} />,
    },
    {
      accessorKey: 'category',
      header: formatMessage({ id: 'rewards.earnings.table.category' }),
      ...fluidColumn({ min: 100, align: 'center', headerAlign: 'center' }),
    },
    {
      accessorKey: 'detail',
      header: formatMessage({ id: 'rewards.earnings.table.detail' }),
      ...fluidColumn({ min: 100, align: 'center', headerAlign: 'center' }),
      // Wrapped under DataGridPro's auto row height; DS cells never wrap, so this truncates and
      // `TruncatedText` reveals the full value — only when it is actually clipped.
      cell: ({ row }) => <TruncatedText variant="body2">{row.original.detail}</TruncatedText>,
    },
  ])
}
